import { get } from '@starsoft/common/utils';
import { FieldPath, FieldValues } from 'react-hook-form';

/**
 * Filters an array of options based on a search value and specified fields to filter by.
 * Options that start with the search value are prioritized (added to start of results),
 * while options that contain the search value are added to the end.
 *
 * @template T - Generic type extending FieldValues for form handling
 * @template V - Generic type for the search value
 * @param {T[]} options - Array of options to filter
 * @param {V} value - Search value to filter options by
 * @param {FieldPath<T>[]} filterBy - Array of field paths to check against the search value
 * @returns {T[]} Filtered array of options, with exact matches first followed by partial matches
 */
export function filterOptions<T extends FieldValues, V>(
  options: T[],
  value: V,
  filterBy: FieldPath<T>[],
): T[] {
  const filteredOptions: T[] = [];
  let formatedValue = `${value}`.trimEnd().trimStart();

  for (let i = 0; i < options.length; i++) {
    const option = options[i];

    for (let j = 0; j < filterBy.length; j++) {
      const filter = filterBy[j];
      const optionValue = get(option, filter);

      if (!optionValue) continue;

      if (
        `${optionValue}`.toLowerCase().startsWith(formatedValue.toLowerCase())
      ) {
        filteredOptions.unshift(option);
        break;
      }

      if (
        `${optionValue}`.toLowerCase().includes(formatedValue.toLowerCase())
      ) {
        filteredOptions.push(option);
        break;
      }
    }
  }

  return filteredOptions;
}
